import { ResponsePanelItemController } from '../controller/ResponsePanelItemController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { Action } from '../types';
import { GridViews } from '../../responseGrid/types';

export class ResponsePanelItemWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ResponsePanelItemController,
    });
  }

  get actionCategoryName(): string {
    return this.getAttribute('data-action-category-name') || '';
  }

  set actionCategoryName(actionCategoryName: string) {
    this.setAttribute('data-action-category-name', actionCategoryName);
  }

  get actions(): Array<Action> {
    const value = this.getAttribute('data-actions');
    return value ? JSON.parse(value) : [];
  }

  set actions(actions: Array<Action>) {
    this.setAttribute('data-actions', JSON.stringify(actions));
  }

  get category(): number {
    const category = this.getAttribute('data-category');
    return category ? parseInt(category, 10) : 0;
  }

  set category(category: number) {
    this.setAttribute('data-category', category.toString());
  }

  get view(): GridViews {
    const view = this.getAttribute('data-view') as GridViews;
    return view;
  }

  set view(view: GridViews) {
    this.setAttribute('data-view', view.toString());
  }
}
